import { Templates } from '@/types/common';

export const ADYEN_CARD_STYLES: Record<string, unknown> = {
  base: {
    color: '#000000',
    fontSize: '16px',
    fontSmoothing: 'antialiased',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif !important',
    lineHeight: '1.5',
    outline: 'none !important',
    border: 'none',
    padding: '0 8px',
  },
  error: {
    color: '#ef4444',
    outline: 'none',
    border: 'none',
  },
  validated: {
    color: '#000000',
    border: 'none',
    outline: 'none',
  },
  placeholder: {
    color: '#9ca3af',
    fontWeight: '400',
    border: 'none',
    outline: 'none',
  },
  focus: {
    color: '#000000',
    border: 'none',
    outline: 'none',
  },
};

// Component Style Constants
export const DETAILS_STYLES = {
  base: 'flex flex-col sm:w-full landscape:h-[100dvh] landscape:overflow-y-auto',
  default: 'mt-11 pl-4 pr-4 w-full md:mt-15 md:pl-0 md:pr-0 md:items-center',
  onePayment: 'mt-0 px-0 w-full',
  wrapper: {
    desktop: 'flex flex-col md:w-5/6',
    onePayment: 'flex flex-col gap-1 w-full',
  },
  collapsible: {
    base: 'overflow-hidden flex flex-col transition-all duration-300 ease-in-out',
    onePayment: {
      open: 'max-h-[500px] opacity-100 gap-1',
      closed: 'max-h-0 opacity-0',
    },
    mobile: {
      open: 'max-h-96 opacity-100 gap-4',
      closed: 'max-h-0 opacity-0',
    },
  },
  totalPrice: {
    default: 'mt-1',
    mobile: 'mt-4',
  },
} as const;

export const PAYMENT_STYLES = {
  base: 'flex flex-col h-full',
  default:
    'mx-4 md:mx-0 gap-4 md:items-center landscape:items-center landscape:justify-start landscape:mx-0 landscape:px-4 landscape:pt-15',
  onePayment: 'mt-4 px-0 w-full gap-2',
} as const;

// Template-based style getters
export const getDetailsContainerStyles = (templateType: Templates) => {
  return templateType === Templates.OnePayment ? DETAILS_STYLES.onePayment : DETAILS_STYLES.default;
};

export const getDetailsCollapsibleStyles = (templateType: Templates, isOpen: boolean) => {
  const isOnePayment = templateType === Templates.OnePayment;
  const stateStyles = isOnePayment
    ? isOpen
      ? DETAILS_STYLES.collapsible.onePayment.open
      : DETAILS_STYLES.collapsible.onePayment.closed
    : isOpen
      ? DETAILS_STYLES.collapsible.mobile.open
      : DETAILS_STYLES.collapsible.mobile.closed;

  return `${DETAILS_STYLES.collapsible.base} ${stateStyles} w-full`;
};

export const getDetailsWrapperStyles = (templateType: Templates, isMobile: boolean) => {
  if (templateType === Templates.OnePayment) {
    return DETAILS_STYLES.wrapper.onePayment;
  }
  return isMobile ? '' : DETAILS_STYLES.wrapper.desktop;
};

export const getDetailsTotalPriceStyles = (templateType: Templates, isMobile: boolean) => {
  return isMobile && templateType !== Templates.OnePayment
    ? DETAILS_STYLES.totalPrice.mobile
    : DETAILS_STYLES.totalPrice.default;
};

export const getPaymentContainerStyles = (templateType: Templates) => {
  return templateType === Templates.OnePayment ? PAYMENT_STYLES.onePayment : PAYMENT_STYLES.default;
};
